"use client";

import { isEditing, isPreviewing } from "@builder.io/sdk-react";
import { FC, useEffect, useState } from "react";

export type IconBlockProps = {
  icon: string;
  width?: number;
  height?: number;
  color?: string;
};

export const IconBlock: FC<IconBlockProps> = ({
  icon,
  width,
  height,
  color,
}) => {
  const [svg, setSvg] = useState("");

  useEffect(() => {
    const getSvgContent = async (icon: string) => {
      const response = await fetch(icon);
      const content = await response.text();

      setSvg(content);
    };

    getSvgContent(icon);
  }, [icon]);

  if (!icon) {
    return <div className="bg-red-300">Missing icon source!</div>;
  }

  return (
    <div
      style={{
        color,
        width,
        height,
      }}
      className="[&_svg]:fill-[currentColor]"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};
